import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { flushedFocusVisible, outlineFieldSurface, outlineFocusVisible } from './focus-styles';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

export const Input = defineMultiStyleConfig({
	variants: {
		outline: {
			field: {
				...outlineFieldSurface,
				...outlineFocusVisible,
			},
		},
		filled: {
			field: outlineFocusVisible,
		},
		flushed: {
			field: flushedFocusVisible,
		},
	},
});
